import { apiGetAuth, apiPutAuth } from '@/utils/api'
import { API_UPDATED } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  updated_list: { 
    isLoading: false,
    data: false
  },
  detail_updated: {
    isLoading: false,
    data: false
  },
  modal_updating: {
    isOpen: false,
    isLoading: false
  },
  detail_modal_preview: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_UPDATED_LIST": (state, payload) => {
    state.updated_list = payload
  },
  "SET_DETAIL_UPDATED": (state, payload) => {
    state.detail_updated = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_DETAIL_MODAL_PREVIEW": (state, payload) => {
    state.detail_modal_preview = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  },
  "SET_MODAL_UPDATING": (state, payload) => {
    state.modal_updating = payload
  }
}

const actions = {
  async getUpdatedList(context, payload) {
    try {
      context.commit('SET_UPDATED_LIST', {isLoading: true})
      const response = await apiGetAuth(API_UPDATED.LIST, payload)
      context.commit('SET_UPDATED_LIST', {isLoading: false, data: response.data})
      context.commit('SET_META_FILTER', payload)
    } catch (err) {
      context.commit('SET_UPDATED_LIST', {isLoading: false, data: false})
      notificationDanger(err)
    }
  },
  async getDetailUpdated(context, payload) {
    try {
      context.commit('SET_DETAIL_UPDATED', {isLoading: true})
      const response = await apiGetAuth(API_UPDATED.BY_ID(payload))
      context.commit('SET_DETAIL_UPDATED', {isLoading: false, data: response.data})
    } catch (error) {
      context.commit('SET_DETAIL_UPDATED', {isLoading: false, data: false})
      notificationDanger(error)
    }
  },
  async updatingData(context, payload) {
    try {
      const response = await apiPutAuth(API_UPDATED.BY_ID(payload.id), payload.body)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  }
}

const getters = {
  get_updated_list: state => {
    return state.updated_list
  },
  get_detail_updated: state => {
    return state.detail_updated
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  get_detail_modal_preview: state => {
    return state.detail_modal_preview
  },
  meta_filter: state => {
    return state.meta_filter
  },
  modal_updating: state => {
    return state.modal_updating
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
